const getCssProp = (el, prop) => {
  if (!el || !prop) return;

  const value = getComputedStyle(el)[prop];
  if (value.indexOf('px') < 0) return;
  return parseFloat(value.replace('px', ''));
};

const calcElHeight = (el, includeMargin = true) => {
  if (!el) return;
  const borderTop = getCssProp(el, 'border-top-width');
  const borderBottom = getCssProp(el, 'border-bottom-width');
  const buffer = el.clientHeight + borderTop + borderBottom;
  if (!includeMargin) return buffer;
  const marginTop = getCssProp(el, 'margin-top');
  const marginBottom = getCssProp(el, 'margin-bottom');
  return buffer + marginTop + marginBottom;
};

const openAccordion = (details) => {
  if (!details || details.classList.contains('is-animating')) return;
  if (details.open) return;
  details.classList.add('is-animating');
  const content = details.querySelector(':scope > .accordion__content');
  if (!content) return;

  const startHeight = calcElHeight(details, false);
  details.style.height = `${startHeight}px`;
  details.style.overflow = 'hidden';
  details.open = true;
  window.requestAnimationFrame(() => {
    const endHeight = startHeight + calcElHeight(content);
    const animation = details.animate(
      {
        height: [`${startHeight}px`, `${endHeight}px`],
      },
      {
        duration: 400,
        easing: 'ease-out',
      },
    );
    animation.onfinish = () => {
      details.classList.remove('is-animating');
      details.style.height = '';
      details.style.overflow = '';
    };
  });
};

const closeAccordion = (details) => {
  if (!details || details.classList.contains('is-animating')) return;
  if (!details.open) return;
  details.classList.add('is-animating');
  const content = details.querySelector(':scope > .accordion__content');
  if (!content) return;

  const startHeight = calcElHeight(details, false);
  const endHeight = startHeight - calcElHeight(content);
  details.style.height = `${startHeight}px`;
  details.style.overflow = 'hidden';
  window.requestAnimationFrame(() => {
    const animation = details.animate(
      {
        height: [`${startHeight}px`, `${endHeight}px`],
      },
      {
        duration: 400,
        easing: 'ease-out',
      },
    );
    animation.onfinish = () => {
      details.classList.remove('is-animating');
      details.style.height = '';
      details.style.overflow = '';
      details.open = false;
    };
  });
};

const initAccordions = (root = document) => {
  if (!root) return;
  const rootEl = typeof root === 'string' ? document.querySelector(root) : root;
  if (!rootEl) return;

  rootEl.querySelectorAll('details').forEach((details) => {
    const summary = details.querySelector(':scope > summary');
    const content = details.querySelector(':scope > .accordion__content');
    if (!summary || !content) return;

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      let rel = e.target.getAttribute('rel');

      if (
        !details.open &&
        typeof details.dataset.exclusive !== 'undefined' &&
        details.dataset.index
      ) {
        let detailsSelector = document.querySelectorAll(
          `details:not([data-index="${details.dataset.index}"])${details.dataset.group ? `[data-group="${details.dataset.group}"]` : ''}`,
        );
        if (rel != null) {
          detailsSelector = document.querySelectorAll(
            `#${rel} details:not([data-index="${details.dataset.index}"])${details.dataset.group ? `[data-group="${details.dataset.group}"]` : ''}`,
          );
        }

        detailsSelector.forEach((details) => closeAccordion(details));
      }

      details.open ? closeAccordion(details) : openAccordion(details);
    });
  });
};

export { initAccordions, openAccordion, closeAccordion };
